export const THEME_STORAGE_KEY = "lst_ui_theme_preset";
export const DEFAULT_THEME_ID = "yst";
const YST_OFFICIAL_VARS = {
    "--van-primary-color": "#fc7731",
    "--van-loading-spinner-color": "#fc7731",
    "--app-bg-page": "linear-gradient(180deg, #fafafa 0%, #f5f5f5 50%, #f0f0f0 100%)",
    "--app-bg-page-warm": "linear-gradient(180deg, #ffffff 0%, #f7f7f7 48%, #f2f2f2 100%)",
    "--app-bg-detail": "linear-gradient(180deg, #ffffff 0%, #f5f5f5 40%)",
    "--app-accent": "#fc7731",
    "--app-accent-hot": "#e86520",
    "--app-accent-muted": "#c55a1a",
    "--app-price": "#323233",
    "--app-nav-surface": "rgba(255, 255, 255, 0.96)",
    "--app-card-shadow": "0 0 5px 1px rgba(0, 0, 0, 0.05)",
    "--app-card-shadow-hover": "0 4px 16px rgba(0, 0, 0, 0.08)",
    "--app-card-radius": "12px",
    "--app-tag-gold-from": "#ffb347",
    "--app-tag-gold-to": "#fc7731",
    "--app-tag-gold-text": "#ffffff",
    "--app-buy-gradient-from": "#fc7731",
    "--app-buy-gradient-to": "#e85d1a",
    "--app-text-primary": "#323233",
    "--app-text-secondary": "#646566",
    "--app-text-muted": "#969799",
    "--app-border-subtle": "rgba(0, 0, 0, 0.06)",
    "--app-surface-glass": "#ffffff",
    "--app-tabbar-bg": "rgba(255, 255, 255, 0.98)",
    "--app-list-bg": "linear-gradient(180deg, #f7f8fa 0%, #f2f3f5 100%)",
    "--app-badge-sale-bg": "rgba(252, 119, 49, 0.12)",
    "--app-badge-sale-text": "#fc7731",
    "--app-badge-panic-bg": "rgba(252, 119, 49, 0.08)",
    "--app-badge-panic-text": "#e85d1a",
    "--app-dash-gradient": "linear-gradient(145deg, #fc7731 0%, #e85d1a 55%, #d94e0f 100%)",
    "--app-profit-win": "#07c160",
    "--app-profit-lose": "#ee0a24",
    "--app-notice-bg": "rgba(252, 119, 49, 0.08)",
    "--app-notice-text": "#c55a1a",
    "--app-link-blue": "#fc7731",
    "--app-pill-active-bg": "#fc7731",
    "--app-pill-active-text": "#ffffff",
    "--app-tab-ink": "#fc7731",
    "--app-limit-tag-bg": "rgba(252, 119, 49, 0.15)",
    "--app-limit-tag-text": "#e65100"
};
const MAGENTA_BRIGHT_VARS = {
    "--van-primary-color": "#e91e8c",
    "--van-loading-spinner-color": "var(--van-primary-color)",
    "--app-bg-page": "linear-gradient(180deg, #ffffff 0%, #f5f5f7 45%, #f0f0f3 100%)",
    "--app-bg-page-warm": "linear-gradient(180deg, #ffffff 0%, #f6f6f8 48%, #f1f1f4 100%)",
    "--app-bg-detail": "linear-gradient(180deg, #ffffff 0%, #f5f5f7 40%)",
    "--app-accent": "#e91e8c",
    "--app-accent-hot": "#d81b60",
    "--app-accent-muted": "#ad1457",
    "--app-price": "#1a1a1a",
    "--app-nav-surface": "rgba(255, 255, 255, 0.96)",
    "--app-card-shadow": "0 2px 14px rgba(233, 30, 140, 0.06), 0 1px 3px rgba(0, 0, 0, 0.04)",
    "--app-card-shadow-hover": "0 8px 28px rgba(233, 30, 140, 0.1), 0 2px 8px rgba(0, 0, 0, 0.05)",
    "--app-card-radius": "14px",
    "--app-tag-gold-from": "#ffb74d",
    "--app-tag-gold-to": "#ff8c42",
    "--app-tag-gold-text": "#ffffff",
    "--app-buy-gradient-from": "#ff8c42",
    "--app-buy-gradient-to": "#ff6b35",
    "--app-text-primary": "#1a1a1a",
    "--app-text-secondary": "#5a5a5a",
    "--app-text-muted": "#9e9e9e",
    "--app-border-subtle": "rgba(0, 0, 0, 0.06)",
    "--app-surface-glass": "#ffffff",
    "--app-tabbar-bg": "rgba(255, 255, 255, 0.98)",
    "--app-list-bg": "linear-gradient(180deg, #f5f5f7 0%, #ebebef 100%)",
    "--app-badge-sale-bg": "rgba(233, 30, 140, 0.08)",
    "--app-badge-sale-text": "#c2185b",
    "--app-badge-panic-bg": "rgba(255, 140, 66, 0.12)",
    "--app-badge-panic-text": "#e65100",
    "--app-dash-gradient": "linear-gradient(145deg, #e91e8c 0%, #9c27b0 55%, #7b1fa2 100%)",
    "--app-profit-win": "#2e7d32",
    "--app-profit-lose": "#c62828",
    "--app-notice-bg": "rgba(233, 30, 140, 0.06)",
    "--app-notice-text": "#ad1457",
    "--app-link-blue": "#e91e8c",
    "--app-pill-active-bg": "#ff8c42",
    "--app-pill-active-text": "#ffffff",
    "--app-tab-ink": "#e91e8c",
    "--app-limit-tag-bg": "rgba(255, 140, 66, 0.15)",
    "--app-limit-tag-text": "#e65100"
};
const SOFT_COMFORT_VARS = {
    "--app-bg-page": "linear-gradient(168deg, #f3f4f6 0%, #eceef2 48%, #e6e9ef 100%)",
    "--app-bg-page-warm": "linear-gradient(168deg, #f4f5f7 0%, #eceef3 48%, #e5e8ee 100%)",
    "--app-bg-detail": "linear-gradient(180deg, #f7f8fa 0%, #eef0f4 42%)",
    "--app-accent": "#7d6f50",
    "--app-accent-hot": "#8b6048",
    "--app-accent-muted": "#6b6352",
    "--app-price": "#8a6560",
    "--app-nav-surface": "rgba(255, 255, 255, 0.9)",
    "--app-card-shadow": "0 2px 16px rgba(15, 23, 42, 0.05), 0 1px 2px rgba(15, 23, 42, 0.03)",
    "--app-card-shadow-hover": "0 10px 32px rgba(15, 23, 42, 0.08), 0 2px 6px rgba(15, 23, 42, 0.04)",
    "--app-card-radius": "16px",
    "--app-tag-gold-from": "#e2ddd4",
    "--app-tag-gold-to": "#c9c0b0",
    "--app-tag-gold-text": "#3d3a34",
    "--app-buy-gradient-from": "#9a8b6e",
    "--app-buy-gradient-to": "#6f5f48",
    "--app-text-primary": "#1c1d21",
    "--app-text-secondary": "#5c6068",
    "--app-text-muted": "#8b9099",
    "--app-border-subtle": "rgba(28, 29, 33, 0.07)",
    "--app-surface-glass": "rgba(255, 255, 255, 0.82)",
    "--app-tabbar-bg": "rgba(255, 255, 255, 0.93)",
    "--app-list-bg": "linear-gradient(180deg, #eef0f4 0%, #e4e7ed 100%)",
    "--app-badge-sale-bg": "rgba(125, 111, 80, 0.1)",
    "--app-badge-sale-text": "#6b6048",
    "--app-badge-panic-bg": "rgba(138, 101, 96, 0.1)",
    "--app-badge-panic-text": "#8a6560",
    "--app-dash-gradient": "linear-gradient(148deg, #3d4551 0%, #2a3038 100%)",
    "--app-profit-win": "#4d7c6f",
    "--app-profit-lose": "#9a6560",
    "--app-notice-bg": "rgba(125, 111, 80, 0.08)",
    "--app-notice-text": "#5c5648",
    "--app-link-blue": "#4a6fa5",
    "--app-pill-active-bg": "#9a8b6e",
    "--app-pill-active-text": "#ffffff",
    "--app-tab-ink": "#7d6f50",
    "--app-limit-tag-bg": "rgba(255, 140, 66, 0.12)",
    "--app-limit-tag-text": "#e65100",
    "--van-primary-color": "#7d6f50",
    "--van-loading-spinner-color": "#7d6f50"
};
export const THEME_PRESETS = [
    {
        id: "magenta",
        name: "\u4EAE\u5F69",
        cssVars: MAGENTA_BRIGHT_VARS
    },
    {
        id: "yst",
        name: "\u539F\u751F\u989C\u8272",
        cssVars: YST_OFFICIAL_VARS
    },
    {
        id: "comfort",
        name: "\u8212\u9002\u62A4\u773C",
        cssVars: SOFT_COMFORT_VARS
    },
    {
        id: "warm",
        name: "\u6696\u6C99\u91D1",
        cssVars: {
            "--app-bg-page": "linear-gradient(168deg, #faf7f0 0%, #f3ece2 45%, #ebe4d8 100%)",
            "--app-bg-page-warm": "linear-gradient(168deg, #faf7f0 0%, #f2eadc 48%, #e8e0d4 100%)",
            "--app-bg-detail": "linear-gradient(180deg, #faf8f3 0%, #f0ebe3 42%)",
            "--app-accent": "#9a7a3a",
            "--app-accent-hot": "#a85f2c",
            "--app-accent-muted": "#7d6230",
            "--app-price": "#8f5f56",
            "--app-nav-surface": "rgba(255, 252, 247, 0.9)",
            "--app-tag-gold-from": "#e9dcc4",
            "--app-tag-gold-to": "#d4bc8a",
            "--app-tag-gold-text": "#4a3d24",
            "--app-buy-gradient-from": "#c9a06a",
            "--app-buy-gradient-to": "#9a7340",
            "--app-text-primary": "#1c1914",
            "--app-text-secondary": "#5e574c",
            "--app-text-muted": "#8a8275",
            "--app-border-subtle": "rgba(60, 48, 32, 0.09)",
            "--app-surface-glass": "rgba(255, 252, 248, 0.88)",
            "--app-tabbar-bg": "rgba(255, 252, 247, 0.96)",
            "--app-list-bg": "linear-gradient(180deg, rgba(250, 247, 240, 0.95) 0%, #ebe6dc 100%)",
            "--app-badge-sale-bg": "rgba(154, 122, 58, 0.1)",
            "--app-badge-sale-text": "#7a6230",
            "--app-badge-panic-bg": "rgba(143, 95, 86, 0.12)",
            "--app-badge-panic-text": "#8f5f56",
            "--app-dash-gradient": "linear-gradient(148deg, #4a4238 0%, #2f2a24 100%)",
            "--app-pill-active-bg": "#c9a06a",
            "--app-pill-active-text": "#ffffff",
            "--app-tab-ink": "#9a7a3a",
            "--app-limit-tag-bg": "rgba(201, 160, 106, 0.2)",
            "--app-limit-tag-text": "#6d4c1c",
            "--van-primary-color": "#9a7a3a",
            "--van-loading-spinner-color": "#9a7a3a"
        }
    },
    {
        id: "cool",
        name: "\u51B7\u7070\u84DD",
        cssVars: {
            "--app-bg-page": "linear-gradient(168deg, #f1f4f8 0%, #e9eef5 50%, #e2e8f0 100%)",
            "--app-bg-page-warm": "linear-gradient(168deg, #f2f5f9 0%, #eaeff6 50%, #e3e9f2 100%)",
            "--app-bg-detail": "linear-gradient(180deg, #f6f8fb 0%, #eceff4 42%)",
            "--app-accent": "#4a6b8a",
            "--app-accent-hot": "#3d5f80",
            "--app-accent-muted": "#5c6d7e",
            "--app-price": "#4d6678",
            "--app-nav-surface": "rgba(255, 255, 255, 0.86)",
            "--app-tag-gold-from": "#d5dde8",
            "--app-tag-gold-to": "#aeb9c9",
            "--app-tag-gold-text": "#2c3540",
            "--app-buy-gradient-from": "#6b8cae",
            "--app-buy-gradient-to": "#4a6582",
            "--app-text-primary": "#1a202c",
            "--app-text-secondary": "#4a5568",
            "--app-text-muted": "#718096",
            "--app-border-subtle": "rgba(30, 41, 59, 0.09)",
            "--app-surface-glass": "rgba(255, 255, 255, 0.82)",
            "--app-tabbar-bg": "rgba(255, 255, 255, 0.94)",
            "--app-list-bg": "linear-gradient(180deg, #eef2f7 0%, #e4eaf2 100%)",
            "--app-badge-sale-bg": "rgba(74, 107, 138, 0.12)",
            "--app-badge-sale-text": "#3d5a75",
            "--app-badge-panic-bg": "rgba(77, 102, 120, 0.14)",
            "--app-badge-panic-text": "#3d5568",
            "--app-dash-gradient": "linear-gradient(148deg, #334155 0%, #1e293b 100%)",
            "--app-pill-active-bg": "#4a6582",
            "--app-pill-active-text": "#ffffff",
            "--app-tab-ink": "#4a6b8a",
            "--app-limit-tag-bg": "rgba(74, 101, 138, 0.12)",
            "--app-limit-tag-text": "#3d5a75",
            "--van-primary-color": "#4a6b8a",
            "--van-loading-spinner-color": "#4a6b8a"
        }
    },
    {
        id: "vivid",
        name: "\u9C9C\u660E\u6A21\u5F0F",
        cssVars: {
            "--app-accent": "#c17f0a",
            "--app-accent-hot": "#d35400",
            "--app-accent-muted": "#8a5a00",
            "--app-price": "#b83232",
            "--app-tag-gold-from": "#f0d78c",
            "--app-tag-gold-to": "#d9a84a",
            "--app-tag-gold-text": "#4a3508",
            "--app-buy-gradient-from": "#e8954a",
            "--app-buy-gradient-to": "#c45c1a",
            "--app-badge-sale-bg": "#fff3e0",
            "--app-badge-sale-text": "#b45309",
            "--app-badge-panic-bg": "#ffebee",
            "--app-badge-panic-text": "#c62828",
            "--app-dash-gradient": "linear-gradient(135deg, #5c6bc0 0%, #3949ab 100%)",
            "--app-pill-active-bg": "#e65100",
            "--app-pill-active-text": "#ffffff",
            "--app-tab-ink": "#e65100",
            "--app-limit-tag-bg": "rgba(230, 81, 0, 0.15)",
            "--app-limit-tag-text": "#bf360c",
            "--van-primary-color": "#e65100",
            "--van-loading-spinner-color": "#e65100"
        }
    }
];
export function getPresetById(id) {
    return THEME_PRESETS.find((p) => p.id === id) || THEME_PRESETS[0];
}
export function getStoredThemeId() {
    try {
        const v = localStorage.getItem(THEME_STORAGE_KEY);
        if (v && THEME_PRESETS.some((p) => p.id === v))
            return v;
    }
    catch (e) {
    }
    return DEFAULT_THEME_ID;
}
